import { createSlice } from "@reduxjs/toolkit";
import { AddGPU, UpdateGPU, GetGPUList } from "services/other/gpu.service";
import { toast } from 'react-toastify';

export const gpuAddSlice = createSlice({
  name: "gpuAdd",
  initialState: {
    gpuAdd: {},
    gpuAddLoading: false,
    gpuAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddGPU.pending, (state) => {
      // toast.loading('We are adding the gpu 🤯')
      state.gpuAddLoading = true
    });

    builder.addCase(AddGPU.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New gpu added successfully 👌');

      state.gpuAdd = action.payload
      state.gpuAddLoading = false
      state.gpuAddError = null
    });

    builder.addCase(AddGPU.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the gpu 😣")

      state.gpuAddLoading = false
      state.gpuAddError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const gpuUpdateSlice = createSlice({
  name: "gpuUpdate",
  initialState: {
    gpuUpdate: {},
    gpuUpdateLoading: false,
    gpuUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateGPU.pending, (state) => {
      // toast.loading('We are updating the gpu 🤯')
      state.gpuUpdateLoading = true
    });

    builder.addCase(UpdateGPU.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Category update successfully 👌');

      state.gpuUpdate = action.payload
      state.gpuUpdateLoading = false
      state.gpuUpdateError = null
    });

    builder.addCase(UpdateGPU.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the gpu 😣")

      state.gpuUpdateLoading = false
      state.gpuUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});



export const gpuListSlice = createSlice({
  name: "gpuList",
  initialState: {
    gpuList: [],
    gpuListLoading: false,
    gpuListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetGPUList.pending, (state) => {
      state.gpuListLoading = true
    });

    builder.addCase(GetGPUList.fulfilled, (state, action) => {
      toast.dismiss();

      state.gpuList = action.payload
      state.gpuListLoading = false
      state.gpuListError = null
    });

    builder.addCase(GetGPUList.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the gpu 😣")

      state.gpuListLoading = false
      state.gpuListError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});